import WidgetLoadingAnimation from 'components/Widgets/WidgetLoadingAnimation';
import WidgetTimeUpdate from 'components/Widgets/WidgetTimeUpdate';

const BaseWidget = ({
  widgetType, // The type of the widget to render.
  dimensions, // The dimensions of the widget to render.
  isLoading, // A boolean indicating if the widget is still loading.
  renderers, // A registry of widget renderers.
  route, // The route of the widget to render.
}) => {
  const renderer = renderers?.[widgetType]; // Get the appropriate renderer based on widgetType

  // Check if the renderer is a valid function
  if (typeof renderer !== 'function') {
    return <div>Unknown widget type: {String(widgetType)}</div>;
  }

  // Show loading animation if the widget is still loading
  if (isLoading) {
    return <WidgetLoadingAnimation widgetName={widgetType} dimensions={dimensions} />;
  }

  // Validate dimensions prop and ensure it has two elements
  if (Array.isArray(dimensions) === false || dimensions?.length !== 2) {
    console.error('The dimensions prop must be an array of two numbers.');
    return null;
  }

  // Layout string is useful for renderer decisions and analytics.
  const layout = `${dimensions[0]}x${dimensions[1]}`;

  return (
    <div className="d-flex flex-column h-100 w-100">
      {/* Keep widget content filling remaining space under the header. */}
      {route ? <WidgetTimeUpdate route={route} realtime /> : null}
      <div className="flex-fill">
        {/* Renderers receive size + layout to stay layout-aware. */}
        {renderer({ widgetType, dimensions, layout })}
      </div>
    </div>
  );
};

export default BaseWidget;
